import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function CitationsBar({ className = "" }) {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setS(r.data)).catch(() => {});
  }, []);
  if (!s) return null;

  const profiles = [
    { url: s.google_business_url, label: "Google", testid: "cite-google" },
    { url: s.tripadvisor_url, label: "Tripadvisor", testid: "cite-tripadvisor" },
    { url: s.yelp_url, label: "Yelp", testid: "cite-yelp" },
    { url: s.facebook_url, label: "Facebook", testid: "cite-facebook" },
    { url: s.instagram_url, label: "Instagram", testid: "cite-instagram" },
    { url: s.twitter_url, label: "X", testid: "cite-twitter" },
    { url: s.linkedin_url, label: "LinkedIn", testid: "cite-linkedin" },
    { url: s.youtube_url, label: "YouTube", testid: "cite-youtube" },
    { url: s.apple_maps_url, label: "Apple Maps", testid: "cite-apple" },
    { url: s.bing_places_url, label: "Bing", testid: "cite-bing" },
    { url: s.bbb_url, label: "BBB", testid: "cite-bbb" },
  ].filter((p) => p.url);

  if (profiles.length === 0) return null;

  return (
    <div className={`flex flex-wrap items-center gap-x-6 gap-y-2 ${className}`} data-testid="citations-bar">
      <span className="font-mono-label text-ink-muted">Find us on</span>
      {profiles.map((p) => (
        <a
          key={p.label}
          href={p.url}
          target="_blank"
          rel="noopener noreferrer"
          className="font-mono-label text-ink-soft hover:text-ember link-underline"
          data-testid={p.testid}
        >
          {p.label}
        </a>
      ))}
    </div>
  );
}
